import { useCallback } from 'react';

import { SJCollection } from '@/shared/lib/sj-orm';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import {
  BankDto,
  ContactType,
  isBankContact,
  isBrokerContact,
} from '@/shared/lib/sj-orm/models/contacts';
import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
import { CollectionName } from '@/shared/lib/sj-orm/types';

export const useBank = () => {
  const colContacts = useSecureJsonCollectionsStore
    .getState()
    .collections.get(CollectionName.CONTACTS);
  const contacts = colContacts
    ? new SJCollection(CollectionName.CONTACTS, colContacts, () => {})
    : null;

  const getBank = useCallback(
    (id?: DtoId): BankDto | undefined => {
      if (!id) return undefined;
      const res = contacts?.findById(id);

      if (!res || (!isBankContact(res) && !isBrokerContact(res))) return undefined;

      if (res.type === ContactType.BROKER) {
        const bank: BankDto = {
          ...res,
          type: ContactType.BANK,
          bankAddress: res.brokerAddress,
        };

        return bank;
      }
      return res;
    },
    [contacts],
  );

  return { getBank };
};
